import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { UserProvider } from "./context/Contex";

import PrivateRoute from "./components/PrivateRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import SmartRedirect from "./components/SmartRedirect";
import Authentication from "./pages/Authentication";
import DashBoard from "./pages/DashBoard";
import Analytics from "./pages/Analytics";
import LoadData from "./pages/LoadData";
import Export from "./pages/Export";
import Notifications from "./pages/Notifications";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Config from "./pages/Config";
import TicketUpdates from "./pages/TicketUpdates";

function App() {
  return (
    <Router>
      <UserProvider>
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/login" element={<Authentication />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Rota raiz com redirecionamento inteligente */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <SmartRedirect />
              </PrivateRoute>
            }
          />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="dashBoard" redirectTo="/">
                  <DashBoard />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Load Data */}
          <Route
            path="/load"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="upload" redirectTo="/">
                  <LoadData />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Analytics */}
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="analytics" redirectTo="/">
                  <Analytics />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Analytics */}
          <Route
            path="/ticketUpdates"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="ticketUpdates" redirectTo="/">
                  <TicketUpdates />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Export */}
          <Route
            path="/export"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="export" redirectTo="/">
                  <Export />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Notifications */}
          <Route
            path="/notifications"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="notifications" redirectTo="/">
                  <Notifications />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Profile - Sempre acessível para usuários autenticados */}
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          {/* Settings */}
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <ProtectedRoute resource="settings" redirectTo="/">
                  <Config />
                </ProtectedRoute>
              </PrivateRoute>
            }
          />

          {/* Rota 404 - redireciona para home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </UserProvider>
    </Router>
  );
}

export default App;